import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74a5422c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "chess-board-wrapper" }
const _hoisted_2 = { class: "chess-board" }

import {
    computed,
    onMounted,
    onUnmounted,
    ref
} from 'vue';
import { useStore } from 'vuex';

import ChessSquare from './ChessSquare.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChessBoard',
  setup(__props) {

_useCssVars(_ctx => ({
  "74e18a51": (boardSize.value)
}))

const boardSize = ref('0px');
const dragSquareState = ref<'selecting' | 'unselecting'>('selecting');

const store = useStore();
const selectedSquares = computed(() => store.state.squares);

function handleDragStart(e: DragEvent, squareIndex: number): void {
    e.dataTransfer?.setDragImage(new Image(), 0, 0);
    toggleSquare(squareIndex);
}

function toggleSquare(squareIndex: number, obeyDragState=false): void {
    if (selectedSquares.value.includes(squareIndex) && (dragSquareState.value === 'unselecting' || !obeyDragState)) {
        store.commit('removeSquare', squareIndex);
        dragSquareState.value = 'unselecting';

    } else if ((dragSquareState.value === 'selecting' || !obeyDragState)){
        store.commit('addSquare', squareIndex);
        dragSquareState.value = 'selecting';
    }
}

// Trying to get a perfect square board using purely CSS
// grid is both messy and likely supported by all browsers.
// Instead, we'll use JS to set the board size to the smallest
// of the board's width, height, and the screen's width and height.
// This will ensure the board is always a perfect square, and ensure
// that the board is always fully visible on the screen.
function setBoardSize(): void {
    const chessBoardWrapper = document.getElementById('chess-board-wrapper');
    if (chessBoardWrapper) {
        const {width: boardWidth, height: boardHeight} = chessBoardWrapper.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        boardSize.value = `${Math.min(boardWidth, boardHeight, screenWidth, screenHeight)}px`;
    }
}

window.addEventListener('resize', setBoardSize);
window.addEventListener('load', setBoardSize);

onMounted(setBoardSize);
onUnmounted(() => {
    window.removeEventListener('resize', setBoardSize);
    window.removeEventListener('load', setBoardSize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(64, (squareIndex) => {
        return _createVNode(ChessSquare, {
          key: squareIndex,
          class: _normalizeClass({
                    selected: selectedSquares.value.includes(squareIndex),
                }),
          squareIndex: squareIndex - 1 /* 0-indexed */,
          draggable: "true",
          onClick: ($event: any) => (toggleSquare(squareIndex)),
          onDragstart: (e) => handleDragStart(e, squareIndex),
          onDragenter: ($event: any) => (toggleSquare(squareIndex, true))
        }, null, 8, ["class", "squareIndex", "onClick", "onDragstart", "onDragenter"])
      }), 64))
    ])
  ]))
}
}

})